import { AxiosResponse } from "axios"
import { ISponsoredProducts } from "../types/sponsoredProducts"
import { IChildData } from "../types/childDataTable"
import $api from "../../../axios"
import { ITagCampaign } from "../types/placement"
import {
  IChangeOffAmazonSettingsBody,
  ISetCampaignTargetAcosBody,
  ITagToCampaignBody,
} from "../types/placementBody"

const api = `/sp/campaignsSkc/`
const campaignsApi = `/sp/campaigns/`

export const ApiPlacementList = async (data) => {
  const result = await $api.post<ISponsoredProducts, AxiosResponse<ISponsoredProducts>>(
    `${api}getPlacement`,
    data
  )
  return result.data
}

export const ApiChild = async (data) => {
  const result = await $api.post<IChildData, AxiosResponse<IChildData>>(`${api}getChildData`, data)
  return result.data
}

export const ApiAddTagToCampaign = async (data: ITagToCampaignBody) => {
  const result = await $api.put<ITagCampaign, AxiosResponse<ITagCampaign>>(
    `${api}addTagToCampaigns`,
    data
  )
  return result.data
}

export const ApiRemoveTagFromCampaign = async (data: ITagToCampaignBody) => {
  const result = await $api.put<ITagCampaign, AxiosResponse<ITagCampaign>>(
    `${api}removeTagFromCampaigns`,
    data
  )
  return result.data
}

export const ApiChangeOffAmazonSettings = async (data: IChangeOffAmazonSettingsBody) => {
  const result = await $api.put<
    IChangeOffAmazonSettingsBody,
    AxiosResponse<IChangeOffAmazonSettingsBody>
  >(`${api}changeOffAmazonSettings`, data)
  return result.data
}

export const ApiSetCampaignTargetAcos = async (data: ISetCampaignTargetAcosBody) => {
  const result = await $api.post<ISetCampaignTargetAcosBody, AxiosResponse<{ isSuccess: boolean }>>(
    `${campaignsApi}set-target-acos`,
    data
  )
  return result.data
}
